import { useGetSectionMetadata, useGetSectionSelections } from "@/api/section";
import { Button } from "@/components/ui/button";
import { LayoutNonNullable } from "@/lib/cms/section-types";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { GridDisplay } from "./GridDisplay";

interface GlobalSelectionProps {
  globalSectionId: string;
}

const GlobalSelection = ({ globalSectionId }: GlobalSelectionProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data: selectedImages } = useGetSectionSelections(globalSectionId);
  const { data: sectionMetadata } = useGetSectionMetadata(globalSectionId);

  return (
    <div className="flex flex-col gap-4">
      <div className="w-full flex justify-between items-center">
        <p className="text-[#0c111d] text-base font-medium font-['Raleway'] leading-normal">
          {t("cms.selection.globalSelection.title")}
        </p>
        <div className="flex gap-3 items-center">
          <Button
            variant={"outline"}
            onClick={() => {
              if (globalSectionId) {
                navigate(`/cms/selection/section/${globalSectionId}/artworks`);
              }
            }}
            disabled={!globalSectionId}
          >
            {t("cms.selection.globalSelection.manageArtworks")}
          </Button>
        </div>
      </div>
      {selectedImages && sectionMetadata && (
        <GridDisplay
          displayable={{ dType: "selection", data: selectedImages }}
          layout={sectionMetadata.layout as LayoutNonNullable}
          visibility={sectionMetadata}
        />
      )}
    </div>
  );
};

export default GlobalSelection;
